<template>
  <div class="balance">
    <div class="top-block">
      <div class="top">
        <div class="top-left">
          <div class="txt1">账户余额</div>
          <div class="txt2">{{ Number(userInfo.rec_money) + Number(userInfo.money) }}</div>
        </div>
        <div class="top-btn" @click="handleJump('RECHARGE')">充值</div>
      </div>
      <div class="top-flex">
        <div class="flex-item">
          <div class="item1">金额 </div>
          <div class="item2">{{ userInfo.rec_money }}</div>
          <img src="@/assets/images_member/per1 (53).png" class="img-arrow" alt="">
        </div>
        <div class="flex-item">
          <div class="item1">推荐 </div>
          <div class="item3">{{ userInfo.money }}</div>
          <img src="@/assets/images_member/per1 (52).png" class="img-arrow" alt="">
        </div>
      </div>
    </div>
    <div class="balance-href">
      <div class="item-href" @click="handleJump('DAIJIESUAN')">
        待结算记录
        <img src="@/assets/images_member/per1 (54).png" class="item-arrow" alt="">
      </div>
      <div class="item-href" @click="handleJump('WITHDRAWAL')">
        我要提现
        <img src="@/assets/images_member/per1 (54).png" class="item-arrow" alt="">
      </div>
      <div class="item-href" @click="handleJump('BALANCELIST')">
        余额明细
        <img src="@/assets/images_member/per1 (54).png" class="item-arrow" alt="">
      </div>
      <div class="item-href" @click="handleJump('BALANCES')">
        提现明细
        <img src="@/assets/images_member/per1 (54).png" class="item-arrow" alt="">
      </div>
      <div class="item-href" @click="hanldeStart">
        使用帮助
        <img src="@/assets/images_member/per1 (54).png" class="item-arrow" alt="">
      </div>
    </div>
  </div>
</template>
<script>

import { Dialog } from 'vant'
export default {
  name: 'balance',
  data () {
    return {

    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    }
  },
  methods: {
    handleJump(type) {
      let path = {}
      switch (type) {
        case 'DAIJIESUAN':
          path = {
            path: '/daijiesuan'
          }
          break
        case 'BALANCELIST':
          path = {
            path: '/balanceList'
          }
          break
        case 'RECHARGE':
          path = {
            path: '/recharge'
          }
          break
        case 'BALANCES':
          path = {
            path: '/balances'
          }
          break

        case 'WITHDRAWAL':
          if (this.userInfo.adapay_account_status === -1) {
            Dialog.confirm({
              // title: '绑定身份信息',
              message: '请先绑定身份信息',
              confirmButtonColor: '#576B95'
            })
              .then(() => {
                path = {path: '/uploadIDCard'}
                this.$router.push(path)
              })
              .catch(() => {
              // on cancel
              })
          } else {
            path = {path: '/withdrawal'}
          }
          break

        default:
          break
      }
      this.$router.push(path)
    },
    hanldeStart() {
      this.$toast('功能开发中')
    }
  }
}
</script>
<style lang="less" scoped>
.balance {
  padding: 20px 14px;
  box-sizing: border-box;
  background-color: #1E2020;
  width: 100vw;
  height: 100vh;

  .top-block {
    background-color: #2F3131;
    border-radius: 10px;
    overflow: hidden;
    height: 162px;

    .top {
      background: linear-gradient(267deg, #F0E1C0 0%, #F3DAA9 100%);
      width: 100%;
      height: 108px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 14px;
      box-sizing: border-box;
      border-radius: 10px;

      .top-left {
        display: flex;
        flex-direction: column;

        .txt1 {
          color: #504632;
          font-size: 12px;
          font-weight: 500;
          margin-bottom: 12px;
        }

        .txt2 {
          font-size: 24px;
          color: #504632;
          font-weight: 600;
          display: flex;
          align-items: baseline;
          line-height: 24px;

          &::before {
            content: "￥";
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }

      .top-btn {
        width: 88px;
        height: 40px;
        background-color: #2F3131;
        text-align: center;
        line-height: 40px;
        border-radius: 100px;
        font-size: 16px;
        color: #F0E1C0;
        font-weight: bold;
      }
    }

    .top-flex {
      display: flex;
      align-items: center;
      height: 54px;

      .flex-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        height: 100%;
        font-size: 14px;
        position: relative;
        padding: 0 14px;
        box-sizing: border-box;

        &:first-child::after {
          position: absolute;
          width: 1px;
          height: 28px;
          right: 0;
          top: 13px;
          content: "";
          background-color: #606060;
        }

        .item1 {
          color: #999999;
          margin-right: 4px;
          line-height: 14px;
        }

        .item2 {
          color: #FFFFFF;
          line-height: 14px;
        }

        .item3 {
          color: #F0E1C0;
        }

        .img-arrow {
          margin-left: 20px;
          width: 6px;
          height: 12px;
        }
      }
    }
  }

  .balance-href {
    margin-top: 20px;

    .item-href {
      display: flex;
      align-items: center;
      height: 65px;
      justify-content: space-between;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: 500;

      .item-arrow {
        width: 8px;
        height: 16px;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/personal/balance.vue